import { render } from "./YouthProtectionLock.vue?vue&type=template&id=bc91ee76&scoped=true"
import script from "./YouthProtectionLock.vue?vue&type=script&lang=js"
export * from "./YouthProtectionLock.vue?vue&type=script&lang=js"

import "./YouthProtectionLock.vue?vue&type=style&index=0&id=bc91ee76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc91ee76"]])

export default __exports__